import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'

class ProgressBar extends React.Component {
  constructor(props) {
    super(props)
  }

  calculateWidthMobile() {
    let stepIndex = this.props.steps.indexOf(this.props.currentStep)
    let numberOfSteps = this.props.steps.length - 1

    if (this.props.currentStep.displayName == 'JobSummary' || this.props.currentStep.displayName == 'SubmitJob' ) {
      stepIndex = 1
      numberOfSteps = 1
    }

    return ((stepIndex / numberOfSteps) * 100) + '%'
  }

  calculateWidth() {
    let closureData = Job.Data.closureSurvey
    let displayName = Job.Data.progressWidth
    let hasClosureData = (closureData.job && typeof closureData.job.id !== 'undefined') ? true : false

    if (this.canProgress() || this.hasMoreDetails()) {
      displayName = this.props.currentStep.displayName
    }

    let stepsWithProgress   = JobWizard.StepSequence.stepsWithProgress()
    let combinedSteps       = JobWizard.StepsWithProgress

    if (hasClosureData) {
      if (this.props.currentStep.displayName === 'SubmitFeedback' && closureData.providerAccountId == null) {
        stepsWithProgress = [...stepsWithProgress.slice(0, stepsWithProgress.indexOf('RateExperience')), ...stepsWithProgress.slice(stepsWithProgress.indexOf('RateExperience') + 1)]
        combinedSteps = [...combinedSteps.slice(0, combinedSteps.indexOf('RateExperience')), ...combinedSteps.slice(combinedSteps.indexOf('RateExperience') + 1)]
      }
      if (this.props.currentStep.displayName === 'SubmitFeedback' && (closureData.value !== null && typeof closureData.value !== 'undefined')) {
        stepsWithProgress = [...stepsWithProgress.slice(0, stepsWithProgress.indexOf('HowMuchDidYouPay')), ...stepsWithProgress.slice(stepsWithProgress.indexOf('HowMuchDidYouPay') + 1)]
        combinedSteps = [...combinedSteps.slice(0, combinedSteps.indexOf('HowMuchDidYouPay')), ...combinedSteps.slice(combinedSteps.indexOf('HowMuchDidYouPay') + 1)]
      }
      if (this.props.currentStep.displayName === 'PostJobAgain') {
        stepsWithProgress = [...stepsWithProgress.slice(0, stepsWithProgress.indexOf('PostJobAgain')), ...stepsWithProgress.slice(stepsWithProgress.indexOf('PostJobAgain') + 1)]
        combinedSteps = [...combinedSteps.slice(0, combinedSteps.indexOf('PostJobAgain')), ...combinedSteps.slice(combinedSteps.indexOf('PostJobAgain') + 1)]
      }
    } else {
      for( var i = stepsWithProgress.length-1; i--;){
        if ( stepsWithProgress[i] === 'HasJobBeenDoneYet') stepsWithProgress.splice(i, 1);
        if ( stepsWithProgress[i] === 'WhoDidTheJob') stepsWithProgress.splice(i, 1);
        if ( stepsWithProgress[i] === 'RateExperience') stepsWithProgress.splice(i, 1);
        if ( stepsWithProgress[i] === 'HowMuchDidYouPay') stepsWithProgress.splice(i, 1);
        if ( stepsWithProgress[i] === 'SubmitFeedback') stepsWithProgress.splice(i, 1);
      }

      for( var i = combinedSteps.length-1; i--;){
        if ( combinedSteps[i] === 'HasJobBeenDoneYet') combinedSteps.splice(i, 1);
        if ( combinedSteps[i] === 'WhoDidTheJob') combinedSteps.splice(i, 1);
        if ( combinedSteps[i] === 'RateExperience') combinedSteps.splice(i, 1);
        if ( combinedSteps[i] === 'HowMuchDidYouPay') combinedSteps.splice(i, 1);
        if ( combinedSteps[i] === 'SubmitFeedback') combinedSteps.splice(i, 1);
      }
    }

    let stepIndex     = combinedSteps.indexOf(displayName)
    let numberOfSteps = combinedSteps.length

    if (this.hasMoreDetails()) {
      if (Job.Data.choseMoreDetails === true) {
        numberOfSteps = combinedSteps.length
        stepIndex     = combinedSteps.indexOf(displayName)
      }
      else {
        numberOfSteps = stepsWithProgress.length
        stepIndex     = stepsWithProgress.indexOf(displayName)
      }
    }

    if (this.props.currentStep.props) {
      if (this.props.currentStep.props.displayName === 'CategoryStep') {
        let indexOfAddedQuestions = combinedSteps.indexOf('MoreDetails') + 1

        while (this.props.currentStep.props.questions[0].key !== combinedSteps[indexOfAddedQuestions].props.questions[0].key) {
          indexOfAddedQuestions++
        }

        stepIndex     = indexOfAddedQuestions
        numberOfSteps = combinedSteps.length
      }
    }

    if (this.props.currentStep.displayName === 'UpdateJob') {
      stepIndex = 1
      numberOfSteps = 1
    }

    if (hasClosureData && this.props.currentStep.displayName === 'PostJobAgain') {
      stepIndex = 1
      numberOfSteps = 1
    }

    return ((stepIndex / numberOfSteps) * 100) + '%'
  }

  canProgress() {
    return JobWizard.StepSequence.stepsWithProgress().includes(this.props.currentStep.displayName)
  }

  hasMoreDetails() {
    return JobWizard.StepSequence.stepsForMoreDetails().includes(this.props.currentStep.displayName)
  }

  render() {
    return(
      <div className="row">
        <div className="col-xs-10 col-sm-11 pr8 sm-pr16">
          <div className="progress mb0 text-align-center" width="100%">
            <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="0" className="progress-bar" role="progressbar" style={{ width: (window.mobilecheck() ? this.calculateWidthMobile() : this.calculateWidth()) }}>
              <span className="sr-only">Step 1 of 2</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProgressBar
